/* ============================================================================
   PLP_003 — mobile slider for the full-width info lines in the product grid.

   `<plp003-slider>` is a custom element, so it re-initialises itself for free
   every time facets.js replaces #ProductGridContainer.innerHTML on filter /
   sort / paginate.

   20-10-2026: PLP_003 is the default grid; the body-class gate is gone.
   Swiper comes from the theme's own deferred swiper-bundle.min.js (global
   window.Swiper). If it is not there yet when the element connects, the
   script waits for it; as a last resort it loads the theme copy whose URL the
   snippet passes in data-swiper-src. Only the mobile viewport (below the
   768px desktop breakpoint) initialises a slider. Until Swiper is ready the
   track is a native scroll-snap carousel (see the CSS).
   ========================================================================== */
(function () {
  'use strict';

  var SWIPER_SRC = '';
  var MOBILE_QUERY = '(max-width: 767.98px)';

  var sliders = new Set();
  var swiperPromise = null;

  function loadSwiper() {
    if (window.Swiper) return Promise.resolve(window.Swiper);
    if (!swiperPromise) {
      swiperPromise = new Promise(function (resolve, reject) {
        var tries = 0;
        var poll = function () {
          if (window.Swiper) return resolve(window.Swiper);
          if (tries++ < 40) return setTimeout(poll, 100);
          if (!SWIPER_SRC) return reject(new Error('PLP_003: Swiper not available'));
          var script = document.createElement('script');
          script.src = SWIPER_SRC;
          script.async = true;
          script.onload = function () { resolve(window.Swiper); };
          script.onerror = function () { swiperPromise = null; reject(new Error('PLP_003: Swiper failed to load')); };
          document.head.appendChild(script);
        };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', poll, { once: true });
        } else {
          poll();
        }
      });
    }
    return swiperPromise;
  }

  var mql = window.matchMedia(MOBILE_QUERY);

  function isRevealed() {
    return true;
  }

  function syncAll() {
    sliders.forEach(function (slider) {
      slider.sync();
    });
  }

  if (mql.addEventListener) {
    mql.addEventListener('change', syncAll);
  } else if (mql.addListener) {
    mql.addListener(syncAll);
  }


  class Plp003Slider extends HTMLElement {
    connectedCallback() {
      if (!SWIPER_SRC && this.dataset.swiperSrc) SWIPER_SRC = this.dataset.swiperSrc;
      sliders.add(this);
      this.sync();
    }

    disconnectedCallback() {
      sliders.delete(this);
      this.teardown();
    }

    sync() {
      if (isRevealed() && mql.matches) {
        this.setup();
      } else {
        this.teardown();
      }
    }

    setup() {
      if (this.swiper || this.pending) return;
      var track = this.querySelector('.plp003-swiper');
      if (!track) return;
      var dots = this.querySelector('.plp003-dots');
      var self = this;
      this.pending = true;
      loadSwiper()
        .then(function (Swiper) {
          self.pending = false;
          // Conditions may have changed while the library was in flight.
          if (self.swiper || !self.isConnected || !isRevealed() || !mql.matches) return;
          self.swiper = new Swiper(track, {
            slidesPerView: 1,
            spaceBetween: 12,
            autoHeight: true,
            watchOverflow: true,
            a11y: { enabled: false },
            pagination: dots ? { el: dots, clickable: true } : false
          });
        })
        .catch(function () {
          self.pending = false;
        });
    }

    teardown() {
      if (!this.swiper) return;
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  if (!customElements.get('plp003-slider')) {
    customElements.define('plp003-slider', Plp003Slider);
  }
})();
